document.addEventListener('DOMContentLoaded', function () {

  // Only run on /es
  if (window.location.pathname === '/es') {

    // Check if user has already selected a language within the last 24 hours
    var lastChoice = localStorage.getItem('languagePopupChoice');
    var currentTime = new Date().getTime();
    var twentyFourHours = 24 * 60 * 60 * 1000;

    if (lastChoice && (currentTime - parseInt(lastChoice)) < twentyFourHours) {
      return;
    }

    // Create popup
    var popup = document.createElement('div');
    popup.id = 'language-popup';

    popup.innerHTML = `
      <div class="language-popup-inner">
        <div class="popup-logo">
            <img src="https://www.thefourth.uk/cdn/shop/files/thefourth-white-icon.png" alt="fourth logo">
        </div>
        <div class="pop-up-content">
            <div class="english-content">
                <h2>How would you prefer to see our site?</h2>
                <div class="language-buttons">
                    <button type="button" id="language-english" class="button button--primary w-auto">
                        English
                    </button>
                </div>
            </div>
            <div class="spain-content">
                <h2>¿Cómo prefieres ver nuestro sitio?</h2>
                <div class="language-buttons">
                    <button type="button" id="language-spanish" class="button button--primary w-auto">
                        Español
                    </button>
                </div>
            </div>
        </div>
      </div>
    `;

    document.body.appendChild(popup);

    // Disable page scrolling
    document.body.classList.add('language-popup-open');

    // English
    document.getElementById('language-english').addEventListener('click', function () {

      // Remember choice for 24 hours
      localStorage.setItem(
        'languagePopupChoice',
        new Date().getTime()
      );

      // Go to English homepage
      window.location.href = 'https://www.thefourth.uk/';
    });

    // Spanish
    document.getElementById('language-spanish').addEventListener('click', function () {

      // Remember choice for 24 hours
      localStorage.setItem(
        'languagePopupChoice',
        new Date().getTime()
      );

      // Close popup
      popup.remove();
      document.body.classList.remove('language-popup-open');
    });

  }

  // restoring brand name on es site
  (function () {
    function replaceFourthText(root) {
      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function (node) {
            const parent = node.parentElement;

            // Ignore scripts, styles, inputs, etc.
            if (
              parent &&
              ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT'].includes(parent.tagName)
            ) {
              return NodeFilter.FILTER_REJECT;
            }

            return /Cuarta|Cuarto/.test(node.nodeValue)
              ? NodeFilter.FILTER_ACCEPT
              : NodeFilter.FILTER_REJECT;
          }
        }
      );

      const nodes = [];
      let node;

      while ((node = walker.nextNode())) {
        nodes.push(node);
      }

      nodes.forEach(function (textNode) {
        textNode.nodeValue = textNode.nodeValue
          .replace(/\bCuarta\b/g, 'The Fourth')
          .replace(/\bCuarto\b/g, 'The Fourth');
      });
    }

    // Initial page content
    replaceFourthText(document.body);

    // Handle content added dynamically by Shopify/apps/AJAX
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (addedNode) {
          if (addedNode.nodeType === Node.TEXT_NODE) {
            addedNode.nodeValue = addedNode.nodeValue
              .replace(/\bCuarta\b/g, 'The Fourth')
              .replace(/\bCuarto\b/g, 'The Fourth');
          } else if (addedNode.nodeType === Node.ELEMENT_NODE) {
            replaceFourthText(addedNode);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();

});